export interface SmartPlanningUiState {
        
    filterPanelVisible:boolean         
    filterOcean:string
    filterTypePlanif:string
    filterMission:string
    filterDateStart:string
    filterDateEnd:string
} 


export const buildDefaultSmartPlanningUiState = ({filterPanelVisible=false,filterOcean="",filterTypePlanif="",filterMission="",filterDateStart="",filterDateEnd=""} = {} ):SmartPlanningUiState =>{
    return {
        filterPanelVisible,                
        filterOcean,
        filterTypePlanif,
        filterMission,
        filterDateStart,
        filterDateEnd
    }    
}